import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconCalendarFilled$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconCalendarFilled extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '4f764dd57394ea21158bd1e5c423e91389c6f137', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'afe98091002cf473ecec436cb5f19bb419ece3ea', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '2fe1184b073888d2337862064ceee492eba0aa6e', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.5 3h-4V2a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v1H9V2a.5.5 0 0 0-.5-.5H8a.5.5 0 0 0-.5.5v1h-4a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-15a.5.5 0 0 0-.5-.5M9 4.5v1a.5.5 0 0 1-.5.5H8a.5.5 0 0 1-.5-.5v-1zm5.5 1v-1H13v1a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-calendar-filled", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-calendar-filled"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-calendar-filled":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCalendarFilled$1);
            }
            break;
    } });
}

const CosmosIconCalendarFilled = CosmosIconCalendarFilled$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconCalendarFilled, defineCustomElement };
